import { pointDecode } from './tink/elliptic_curves.mjs';
import { uint8ArrayFromHexString, hexStringToBase64url, DEFAULT_JWK_MEMBER_BYTE_LENGTH } from '@turnkey/encoding';

function convertTurnkeyApiKeyToJwk(input) {
    const { uncompressedPrivateKeyHex, compressedPublicKeyHex } = input;
    const jwk = pointDecode(uint8ArrayFromHexString(compressedPublicKeyHex));
    // Ensure that d is sufficiently padded
    jwk.d = hexStringToBase64url(uncompressedPrivateKeyHex, DEFAULT_JWK_MEMBER_BYTE_LENGTH);
    return jwk;
}

export { convertTurnkeyApiKeyToJwk };
//# sourceMappingURL=utils.mjs.map
